export default __webpack_public_path__ + "static/media/eqp_model_ppart.511c06e1.png";